/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as McpRouteImport } from './routes/mcp'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LaunchRouteImport } from './routes/launch'
import { Route as HelpRouteImport } from './routes/help'
import { Route as ClippingRouteImport } from './routes/clipping'
import { Route as CaptionsRouteImport } from './routes/captions'
import { Route as ApiRouteImport } from './routes/api'
import { Route as AnnouncementsRouteImport } from './routes/announcements'
import { Route as AiVideoEditorRouteImport } from './routes/ai-video-editor'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as HelpIndexRouteImport } from './routes/help/index'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AnnouncementsIndexRouteImport } from './routes/announcements/index'
import { Route as SShareKeyRouteImport } from './routes/s.$shareKey'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as HelpSlugRouteImport } from './routes/help/$slug'
import { Route as EditorProjectIdRouteImport } from './routes/editor/$projectId'
import { Route as DocsSlugRouteImport } from './routes/docs/$slug'
import { Route as AppTermsRouteImport } from './routes/app/terms'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppProjectsRouteImport } from './routes/app/projects'
import { Route as AppProcessingRouteImport } from './routes/app/processing'
import { Route as AppPrivacyRouteImport } from './routes/app/privacy'
import { Route as AppHelpRouteImport } from './routes/app/help'
import { Route as AppClipResultsRouteImport } from './routes/app/clip-results'
import { Route as AppClipProcessingRouteImport } from './routes/app/clip-processing'
import { Route as AppClipConfigRouteImport } from './routes/app/clip-config'
import { Route as AppCaptionResultsRouteImport } from './routes/app/caption-results'
import { Route as AppCalendarRouteImport } from './routes/app/calendar'
import { Route as AppBrandingRouteImport } from './routes/app/branding'
import { Route as AppAssetsRouteImport } from './routes/app/assets'
import { Route as AppAiCreateRouteImport } from './routes/app/ai-create'
import { Route as AnnouncementsAnnouncementIdRouteImport } from './routes/announcements/$announcementId'
import { Route as AppToolsVoiceoverRouteImport } from './routes/app/tools/voiceover'
import { Route as AppToolsVoiceCloneRouteImport } from './routes/app/tools/voice-clone'
import { Route as AppToolsVideoGenRouteImport } from './routes/app/tools/video-gen'
import { Route as AppToolsTranscriptionRouteImport } from './routes/app/tools/transcription'
import { Route as AppToolsImageGenRouteImport } from './routes/app/tools/image-gen'
import { Route as AppToolsDigitalHumanRouteImport } from './routes/app/tools/digital-human'
import { Route as AppProjectsProjectIdRouteImport } from './routes/app/projects_.$projectId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const McpRoute = McpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LaunchRoute = LaunchRouteImport.update({
  id: '/launch',
  path: '/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const ClippingRoute = ClippingRouteImport.update({
  id: '/clipping',
  path: '/clipping',
  getParentRoute: () => rootRouteImport,
} as any)
const CaptionsRoute = CaptionsRouteImport.update({
  id: '/captions',
  path: '/captions',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiRoute = ApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnouncementsRoute = AnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const AiVideoEditorRoute = AiVideoEditorRouteImport.update({
  id: '/ai-video-editor',
  path: '/ai-video-editor',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HelpRoute,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnouncementsIndexRoute = AnnouncementsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AnnouncementsRoute,
} as any)
const SShareKeyRoute = SShareKeyRouteImport.update({
  id: '/s/$shareKey',
  path: '/s/$shareKey',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpSlugRoute = HelpSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => HelpRoute,
} as any)
const EditorProjectIdRoute = EditorProjectIdRouteImport.update({
  id: '/editor/$projectId',
  path: '/editor/$projectId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/editor/$projectId.lazy').then((d) => d.Route),
)
const DocsSlugRoute = DocsSlugRouteImport.update({
  id: '/docs/$slug',
  path: '/docs/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTermsRoute = AppTermsRouteImport.update({
  id: '/app/terms',
  path: '/app/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/app/settings',
  path: '/app/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: '/app/projects',
  path: '/app/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProcessingRoute = AppProcessingRouteImport.update({
  id: '/app/processing',
  path: '/app/processing',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPrivacyRoute = AppPrivacyRouteImport.update({
  id: '/app/privacy',
  path: '/app/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/app/help',
  path: '/app/help',
  getParentRoute: () => rootRouteImport,
} as any)
const AppClipResultsRoute = AppClipResultsRouteImport.update({
  id: '/app/clip-results',
  path: '/app/clip-results',
  getParentRoute: () => rootRouteImport,
} as any)
const AppClipProcessingRoute = AppClipProcessingRouteImport.update({
  id: '/app/clip-processing',
  path: '/app/clip-processing',
  getParentRoute: () => rootRouteImport,
} as any)
const AppClipConfigRoute = AppClipConfigRouteImport.update({
  id: '/app/clip-config',
  path: '/app/clip-config',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCaptionResultsRoute = AppCaptionResultsRouteImport.update({
  id: '/app/caption-results',
  path: '/app/caption-results',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/app/calendar',
  path: '/app/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const AppBrandingRoute = AppBrandingRouteImport.update({
  id: '/app/branding',
  path: '/app/branding',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAssetsRoute = AppAssetsRouteImport.update({
  id: '/app/assets',
  path: '/app/assets',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAiCreateRoute = AppAiCreateRouteImport.update({
  id: '/app/ai-create',
  path: '/app/ai-create',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnouncementsAnnouncementIdRoute =
  AnnouncementsAnnouncementIdRouteImport.update({
    id: '/$announcementId',
    path: '/$announcementId',
    getParentRoute: () => AnnouncementsRoute,
  } as any)
const AppToolsVoiceoverRoute = AppToolsVoiceoverRouteImport.update({
  id: '/app/tools/voiceover',
  path: '/app/tools/voiceover',
  getParentRoute: () => rootRouteImport,
} as any)
const AppToolsVoiceCloneRoute = AppToolsVoiceCloneRouteImport.update({
  id: '/app/tools/voice-clone',
  path: '/app/tools/voice-clone',
  getParentRoute: () => rootRouteImport,
} as any)
const AppToolsVideoGenRoute = AppToolsVideoGenRouteImport.update({
  id: '/app/tools/video-gen',
  path: '/app/tools/video-gen',
  getParentRoute: () => rootRouteImport,
} as any)
const AppToolsTranscriptionRoute = AppToolsTranscriptionRouteImport.update({
  id: '/app/tools/transcription',
  path: '/app/tools/transcription',
  getParentRoute: () => rootRouteImport,
} as any)
const AppToolsImageGenRoute = AppToolsImageGenRouteImport.update({
  id: '/app/tools/image-gen',
  path: '/app/tools/image-gen',
  getParentRoute: () => rootRouteImport,
} as any)
const AppToolsDigitalHumanRoute = AppToolsDigitalHumanRouteImport.update({
  id: '/app/tools/digital-human',
  path: '/app/tools/digital-human',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/app/projects_/$projectId',
  path: '/app/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/ai-video-editor': typeof AiVideoEditorRoute
  '/announcements': typeof AnnouncementsRouteWithChildren
  '/api': typeof ApiRoute
  '/captions': typeof CaptionsRoute
  '/clipping': typeof ClippingRoute
  '/help': typeof HelpRouteWithChildren
  '/launch': typeof LaunchRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/pricing': typeof PricingRoute
  '/register': typeof RegisterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/app/ai-create': typeof AppAiCreateRoute
  '/app/assets': typeof AppAssetsRoute
  '/app/branding': typeof AppBrandingRoute
  '/app/calendar': typeof AppCalendarRoute
  '/app/caption-results': typeof AppCaptionResultsRoute
  '/app/clip-config': typeof AppClipConfigRoute
  '/app/clip-processing': typeof AppClipProcessingRoute
  '/app/clip-results': typeof AppClipResultsRoute
  '/app/help': typeof AppHelpRoute
  '/app/privacy': typeof AppPrivacyRoute
  '/app/processing': typeof AppProcessingRoute
  '/app/projects': typeof AppProjectsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/terms': typeof AppTermsRoute
  '/docs/$slug': typeof DocsSlugRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/help/$slug': typeof HelpSlugRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/s/$shareKey': typeof SShareKeyRoute
  '/announcements/': typeof AnnouncementsIndexRoute
  '/app/': typeof AppIndexRoute
  '/docs/': typeof DocsIndexRoute
  '/help/': typeof HelpIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/app/tools/digital-human': typeof AppToolsDigitalHumanRoute
  '/app/tools/image-gen': typeof AppToolsImageGenRoute
  '/app/tools/transcription': typeof AppToolsTranscriptionRoute
  '/app/tools/video-gen': typeof AppToolsVideoGenRoute
  '/app/tools/voice-clone': typeof AppToolsVoiceCloneRoute
  '/app/tools/voiceover': typeof AppToolsVoiceoverRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/ai-video-editor': typeof AiVideoEditorRoute
  '/api': typeof ApiRoute
  '/captions': typeof CaptionsRoute
  '/clipping': typeof ClippingRoute
  '/launch': typeof LaunchRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/pricing': typeof PricingRoute
  '/register': typeof RegisterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/app/ai-create': typeof AppAiCreateRoute
  '/app/assets': typeof AppAssetsRoute
  '/app/branding': typeof AppBrandingRoute
  '/app/calendar': typeof AppCalendarRoute
  '/app/caption-results': typeof AppCaptionResultsRoute
  '/app/clip-config': typeof AppClipConfigRoute
  '/app/clip-processing': typeof AppClipProcessingRoute
  '/app/clip-results': typeof AppClipResultsRoute
  '/app/help': typeof AppHelpRoute
  '/app/privacy': typeof AppPrivacyRoute
  '/app/processing': typeof AppProcessingRoute
  '/app/projects': typeof AppProjectsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/terms': typeof AppTermsRoute
  '/docs/$slug': typeof DocsSlugRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/help/$slug': typeof HelpSlugRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/s/$shareKey': typeof SShareKeyRoute
  '/announcements': typeof AnnouncementsIndexRoute
  '/app': typeof AppIndexRoute
  '/docs': typeof DocsIndexRoute
  '/help': typeof HelpIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/app/tools/digital-human': typeof AppToolsDigitalHumanRoute
  '/app/tools/image-gen': typeof AppToolsImageGenRoute
  '/app/tools/transcription': typeof AppToolsTranscriptionRoute
  '/app/tools/video-gen': typeof AppToolsVideoGenRoute
  '/app/tools/voice-clone': typeof AppToolsVoiceCloneRoute
  '/app/tools/voiceover': typeof AppToolsVoiceoverRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/ai-video-editor': typeof AiVideoEditorRoute
  '/announcements': typeof AnnouncementsRouteWithChildren
  '/api': typeof ApiRoute
  '/captions': typeof CaptionsRoute
  '/clipping': typeof ClippingRoute
  '/help': typeof HelpRouteWithChildren
  '/launch': typeof LaunchRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/pricing': typeof PricingRoute
  '/register': typeof RegisterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/app/ai-create': typeof AppAiCreateRoute
  '/app/assets': typeof AppAssetsRoute
  '/app/branding': typeof AppBrandingRoute
  '/app/calendar': typeof AppCalendarRoute
  '/app/caption-results': typeof AppCaptionResultsRoute
  '/app/clip-config': typeof AppClipConfigRoute
  '/app/clip-processing': typeof AppClipProcessingRoute
  '/app/clip-results': typeof AppClipResultsRoute
  '/app/help': typeof AppHelpRoute
  '/app/privacy': typeof AppPrivacyRoute
  '/app/processing': typeof AppProcessingRoute
  '/app/projects': typeof AppProjectsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/terms': typeof AppTermsRoute
  '/docs/$slug': typeof DocsSlugRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/help/$slug': typeof HelpSlugRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/s/$shareKey': typeof SShareKeyRoute
  '/announcements/': typeof AnnouncementsIndexRoute
  '/app/': typeof AppIndexRoute
  '/docs/': typeof DocsIndexRoute
  '/help/': typeof HelpIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/app/projects_/$projectId': typeof AppProjectsProjectIdRoute
  '/app/tools/digital-human': typeof AppToolsDigitalHumanRoute
  '/app/tools/image-gen': typeof AppToolsImageGenRoute
  '/app/tools/transcription': typeof AppToolsTranscriptionRoute
  '/app/tools/video-gen': typeof AppToolsVideoGenRoute
  '/app/tools/voice-clone': typeof AppToolsVoiceCloneRoute
  '/app/tools/voiceover': typeof AppToolsVoiceoverRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/ai-video-editor'
    | '/announcements'
    | '/api'
    | '/captions'
    | '/clipping'
    | '/help'
    | '/launch'
    | '/login'
    | '/mcp'
    | '/pricing'
    | '/register'
    | '/verify-email'
    | '/announcements/$announcementId'
    | '/app/ai-create'
    | '/app/assets'
    | '/app/branding'
    | '/app/calendar'
    | '/app/caption-results'
    | '/app/clip-config'
    | '/app/clip-processing'
    | '/app/clip-results'
    | '/app/help'
    | '/app/privacy'
    | '/app/processing'
    | '/app/projects'
    | '/app/settings'
    | '/app/terms'
    | '/docs/$slug'
    | '/editor/$projectId'
    | '/help/$slug'
    | '/projects/$projectId'
    | '/projects/new'
    | '/s/$shareKey'
    | '/announcements/'
    | '/app/'
    | '/docs/'
    | '/help/'
    | '/projects/'
    | '/app/projects/$projectId'
    | '/app/tools/digital-human'
    | '/app/tools/image-gen'
    | '/app/tools/transcription'
    | '/app/tools/video-gen'
    | '/app/tools/voice-clone'
    | '/app/tools/voiceover'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/ai-video-editor'
    | '/api'
    | '/captions'
    | '/clipping'
    | '/launch'
    | '/login'
    | '/mcp'
    | '/pricing'
    | '/register'
    | '/verify-email'
    | '/announcements/$announcementId'
    | '/app/ai-create'
    | '/app/assets'
    | '/app/branding'
    | '/app/calendar'
    | '/app/caption-results'
    | '/app/clip-config'
    | '/app/clip-processing'
    | '/app/clip-results'
    | '/app/help'
    | '/app/privacy'
    | '/app/processing'
    | '/app/projects'
    | '/app/settings'
    | '/app/terms'
    | '/docs/$slug'
    | '/editor/$projectId'
    | '/help/$slug'
    | '/projects/$projectId'
    | '/projects/new'
    | '/s/$shareKey'
    | '/announcements'
    | '/app'
    | '/docs'
    | '/help'
    | '/projects'
    | '/app/projects/$projectId'
    | '/app/tools/digital-human'
    | '/app/tools/image-gen'
    | '/app/tools/transcription'
    | '/app/tools/video-gen'
    | '/app/tools/voice-clone'
    | '/app/tools/voiceover'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/ai-video-editor'
    | '/announcements'
    | '/api'
    | '/captions'
    | '/clipping'
    | '/help'
    | '/launch'
    | '/login'
    | '/mcp'
    | '/pricing'
    | '/register'
    | '/verify-email'
    | '/announcements/$announcementId'
    | '/app/ai-create'
    | '/app/assets'
    | '/app/branding'
    | '/app/calendar'
    | '/app/caption-results'
    | '/app/clip-config'
    | '/app/clip-processing'
    | '/app/clip-results'
    | '/app/help'
    | '/app/privacy'
    | '/app/processing'
    | '/app/projects'
    | '/app/settings'
    | '/app/terms'
    | '/docs/$slug'
    | '/editor/$projectId'
    | '/help/$slug'
    | '/projects/$projectId'
    | '/projects/new'
    | '/s/$shareKey'
    | '/announcements/'
    | '/app/'
    | '/docs/'
    | '/help/'
    | '/projects/'
    | '/app/projects_/$projectId'
    | '/app/tools/digital-human'
    | '/app/tools/image-gen'
    | '/app/tools/transcription'
    | '/app/tools/video-gen'
    | '/app/tools/voice-clone'
    | '/app/tools/voiceover'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  AiVideoEditorRoute: typeof AiVideoEditorRoute
  AnnouncementsRoute: typeof AnnouncementsRouteWithChildren
  ApiRoute: typeof ApiRoute
  CaptionsRoute: typeof CaptionsRoute
  ClippingRoute: typeof ClippingRoute
  HelpRoute: typeof HelpRouteWithChildren
  LaunchRoute: typeof LaunchRoute
  LoginRoute: typeof LoginRoute
  McpRoute: typeof McpRoute
  PricingRoute: typeof PricingRoute
  RegisterRoute: typeof RegisterRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AppAiCreateRoute: typeof AppAiCreateRoute
  AppAssetsRoute: typeof AppAssetsRoute
  AppBrandingRoute: typeof AppBrandingRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppCaptionResultsRoute: typeof AppCaptionResultsRoute
  AppClipConfigRoute: typeof AppClipConfigRoute
  AppClipProcessingRoute: typeof AppClipProcessingRoute
  AppClipResultsRoute: typeof AppClipResultsRoute
  AppHelpRoute: typeof AppHelpRoute
  AppPrivacyRoute: typeof AppPrivacyRoute
  AppProcessingRoute: typeof AppProcessingRoute
  AppProjectsRoute: typeof AppProjectsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTermsRoute: typeof AppTermsRoute
  DocsSlugRoute: typeof DocsSlugRoute
  EditorProjectIdRoute: typeof EditorProjectIdRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsNewRoute: typeof ProjectsNewRoute
  SShareKeyRoute: typeof SShareKeyRoute
  AppIndexRoute: typeof AppIndexRoute
  DocsIndexRoute: typeof DocsIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppToolsDigitalHumanRoute: typeof AppToolsDigitalHumanRoute
  AppToolsImageGenRoute: typeof AppToolsImageGenRoute
  AppToolsTranscriptionRoute: typeof AppToolsTranscriptionRoute
  AppToolsVideoGenRoute: typeof AppToolsVideoGenRoute
  AppToolsVoiceCloneRoute: typeof AppToolsVoiceCloneRoute
  AppToolsVoiceoverRoute: typeof AppToolsVoiceoverRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp': {
      id: '/mcp'
      path: '/mcp'
      fullPath: '/mcp'
      preLoaderRoute: typeof McpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/launch': {
      id: '/launch'
      path: '/launch'
      fullPath: '/launch'
      preLoaderRoute: typeof LaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clipping': {
      id: '/clipping'
      path: '/clipping'
      fullPath: '/clipping'
      preLoaderRoute: typeof ClippingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/captions': {
      id: '/captions'
      path: '/captions'
      fullPath: '/captions'
      preLoaderRoute: typeof CaptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api': {
      id: '/api'
      path: '/api'
      fullPath: '/api'
      preLoaderRoute: typeof ApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/announcements': {
      id: '/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AnnouncementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-video-editor': {
      id: '/ai-video-editor'
      path: '/ai-video-editor'
      fullPath: '/ai-video-editor'
      preLoaderRoute: typeof AiVideoEditorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/': {
      id: '/help/'
      path: '/'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexRouteImport
      parentRoute: typeof HelpRoute
    }
    '/docs/': {
      id: '/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/app'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/announcements/': {
      id: '/announcements/'
      path: '/'
      fullPath: '/announcements/'
      preLoaderRoute: typeof AnnouncementsIndexRouteImport
      parentRoute: typeof AnnouncementsRoute
    }
    '/s/$shareKey': {
      id: '/s/$shareKey'
      path: '/s/$shareKey'
      fullPath: '/s/$shareKey'
      preLoaderRoute: typeof SShareKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/$slug': {
      id: '/help/$slug'
      path: '/$slug'
      fullPath: '/help/$slug'
      preLoaderRoute: typeof HelpSlugRouteImport
      parentRoute: typeof HelpRoute
    }
    '/editor/$projectId': {
      id: '/editor/$projectId'
      path: '/editor/$projectId'
      fullPath: '/editor/$projectId'
      preLoaderRoute: typeof EditorProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/$slug': {
      id: '/docs/$slug'
      path: '/docs/$slug'
      fullPath: '/docs/$slug'
      preLoaderRoute: typeof DocsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/terms': {
      id: '/app/terms'
      path: '/app/terms'
      fullPath: '/app/terms'
      preLoaderRoute: typeof AppTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/app/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/projects': {
      id: '/app/projects'
      path: '/app/projects'
      fullPath: '/app/projects'
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/processing': {
      id: '/app/processing'
      path: '/app/processing'
      fullPath: '/app/processing'
      preLoaderRoute: typeof AppProcessingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/privacy': {
      id: '/app/privacy'
      path: '/app/privacy'
      fullPath: '/app/privacy'
      preLoaderRoute: typeof AppPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/help': {
      id: '/app/help'
      path: '/app/help'
      fullPath: '/app/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/clip-results': {
      id: '/app/clip-results'
      path: '/app/clip-results'
      fullPath: '/app/clip-results'
      preLoaderRoute: typeof AppClipResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/clip-processing': {
      id: '/app/clip-processing'
      path: '/app/clip-processing'
      fullPath: '/app/clip-processing'
      preLoaderRoute: typeof AppClipProcessingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/clip-config': {
      id: '/app/clip-config'
      path: '/app/clip-config'
      fullPath: '/app/clip-config'
      preLoaderRoute: typeof AppClipConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/caption-results': {
      id: '/app/caption-results'
      path: '/app/caption-results'
      fullPath: '/app/caption-results'
      preLoaderRoute: typeof AppCaptionResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/calendar': {
      id: '/app/calendar'
      path: '/app/calendar'
      fullPath: '/app/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/branding': {
      id: '/app/branding'
      path: '/app/branding'
      fullPath: '/app/branding'
      preLoaderRoute: typeof AppBrandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/assets': {
      id: '/app/assets'
      path: '/app/assets'
      fullPath: '/app/assets'
      preLoaderRoute: typeof AppAssetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/ai-create': {
      id: '/app/ai-create'
      path: '/app/ai-create'
      fullPath: '/app/ai-create'
      preLoaderRoute: typeof AppAiCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/announcements/$announcementId': {
      id: '/announcements/$announcementId'
      path: '/$announcementId'
      fullPath: '/announcements/$announcementId'
      preLoaderRoute: typeof AnnouncementsAnnouncementIdRouteImport
      parentRoute: typeof AnnouncementsRoute
    }
    '/app/tools/voiceover': {
      id: '/app/tools/voiceover'
      path: '/app/tools/voiceover'
      fullPath: '/app/tools/voiceover'
      preLoaderRoute: typeof AppToolsVoiceoverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/tools/voice-clone': {
      id: '/app/tools/voice-clone'
      path: '/app/tools/voice-clone'
      fullPath: '/app/tools/voice-clone'
      preLoaderRoute: typeof AppToolsVoiceCloneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/tools/video-gen': {
      id: '/app/tools/video-gen'
      path: '/app/tools/video-gen'
      fullPath: '/app/tools/video-gen'
      preLoaderRoute: typeof AppToolsVideoGenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/tools/transcription': {
      id: '/app/tools/transcription'
      path: '/app/tools/transcription'
      fullPath: '/app/tools/transcription'
      preLoaderRoute: typeof AppToolsTranscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/tools/image-gen': {
      id: '/app/tools/image-gen'
      path: '/app/tools/image-gen'
      fullPath: '/app/tools/image-gen'
      preLoaderRoute: typeof AppToolsImageGenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/tools/digital-human': {
      id: '/app/tools/digital-human'
      path: '/app/tools/digital-human'
      fullPath: '/app/tools/digital-human'
      preLoaderRoute: typeof AppToolsDigitalHumanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/projects_/$projectId': {
      id: '/app/projects_/$projectId'
      path: '/app/projects/$projectId'
      fullPath: '/app/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AnnouncementsRouteChildren {
  AnnouncementsAnnouncementIdRoute: typeof AnnouncementsAnnouncementIdRoute
  AnnouncementsIndexRoute: typeof AnnouncementsIndexRoute
}

const AnnouncementsRouteChildren: AnnouncementsRouteChildren = {
  AnnouncementsAnnouncementIdRoute: AnnouncementsAnnouncementIdRoute,
  AnnouncementsIndexRoute: AnnouncementsIndexRoute,
}

const AnnouncementsRouteWithChildren = AnnouncementsRoute._addFileChildren(
  AnnouncementsRouteChildren,
)

interface HelpRouteChildren {
  HelpSlugRoute: typeof HelpSlugRoute
  HelpIndexRoute: typeof HelpIndexRoute
}

const HelpRouteChildren: HelpRouteChildren = {
  HelpSlugRoute: HelpSlugRoute,
  HelpIndexRoute: HelpIndexRoute,
}

const HelpRouteWithChildren = HelpRoute._addFileChildren(HelpRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  AiVideoEditorRoute: AiVideoEditorRoute,
  AnnouncementsRoute: AnnouncementsRouteWithChildren,
  ApiRoute: ApiRoute,
  CaptionsRoute: CaptionsRoute,
  ClippingRoute: ClippingRoute,
  HelpRoute: HelpRouteWithChildren,
  LaunchRoute: LaunchRoute,
  LoginRoute: LoginRoute,
  McpRoute: McpRoute,
  PricingRoute: PricingRoute,
  RegisterRoute: RegisterRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AppAiCreateRoute: AppAiCreateRoute,
  AppAssetsRoute: AppAssetsRoute,
  AppBrandingRoute: AppBrandingRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppCaptionResultsRoute: AppCaptionResultsRoute,
  AppClipConfigRoute: AppClipConfigRoute,
  AppClipProcessingRoute: AppClipProcessingRoute,
  AppClipResultsRoute: AppClipResultsRoute,
  AppHelpRoute: AppHelpRoute,
  AppPrivacyRoute: AppPrivacyRoute,
  AppProcessingRoute: AppProcessingRoute,
  AppProjectsRoute: AppProjectsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTermsRoute: AppTermsRoute,
  DocsSlugRoute: DocsSlugRoute,
  EditorProjectIdRoute: EditorProjectIdRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsNewRoute: ProjectsNewRoute,
  SShareKeyRoute: SShareKeyRoute,
  AppIndexRoute: AppIndexRoute,
  DocsIndexRoute: DocsIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppToolsDigitalHumanRoute: AppToolsDigitalHumanRoute,
  AppToolsImageGenRoute: AppToolsImageGenRoute,
  AppToolsTranscriptionRoute: AppToolsTranscriptionRoute,
  AppToolsVideoGenRoute: AppToolsVideoGenRoute,
  AppToolsVoiceCloneRoute: AppToolsVoiceCloneRoute,
  AppToolsVoiceoverRoute: AppToolsVoiceoverRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
